// extracted by mini-css-extract-plugin
module.exports = {"job-card-container":"styles-module__job-card-container___2qYUX"};